import { FrameName } from "../config";
import TileEntity from "../TileEntity";

class GoldVeinTerrainTileEntity extends TileEntity {
	public static readonly frameName = FrameName.GOLD_VEIN;
}

export default GoldVeinTerrainTileEntity;
